module.exports = __webpack_public_path__ + "static/media/my-profile-pic.afa30d0f.png";